import React, {useState, useEffect} from 'react'
import {useList} from 'store/list'
import * as Icons from 'react-feather';

export default function ListPagination(props) {
   const listStore = useList();
   return (<>
      <div className="intro-y col-span-12 flex flex-wrap sm:flex-row sm:flex-nowrap items-center justify-between">
         <ul className="flex w-full justify-center">
            {listStore.page > 1 &&
            <>
               <li className="p-2">
                  <a href="javascript:;" className="pagination__link"
                     onClick={() => props.getList(1)}>
                     <Icons.ChevronsRight className="w-4 h-4"/>
                  </a>
               </li>
               <li className="p-2">
                  <a href="javascript:;" className="pagination__link"
                     onClick={() => props.getList(listStore.page - 1)}>
                     <Icons.ChevronRight className="w-4 h-4"/>
                  </a>
               </li>
            </>
            }

            {/* page numbers */}
            {listStore.page > 2 &&
            <>
               <li className={`p-2 ${listStore.page == 1 ? 'pg-active' : ''}`}>
                  <a href="javascript:;"
                     className="pagination__link"
                     onClick={() => props.getList(1)}>1
                  </a>
               </li>
               <li className={`p-2 ${listStore.page == 2 ? 'pg-active' : ''}`}>
                  <a href="javascript:;" className="pagination__link " onClick={() => props.getList(2)}>2
                  </a>
               </li>
               <li className="p-2"><a href="javascript:;" className="pagination__link" href="">...</a></li>
            </>
            }

            {listStore.page > 1 && listStore.page < 3 &&
            <li className={`p-2 ${listStore.page == (listStore.page - 1) ? 'pg-active' : ''}`}>
               <a href="javascript:;"
                  className="pagination__link"
                  onClick={() => props.getList(listStore.page - 1)}>
                  {listStore.page - 1}
               </a>
            </li>
            }
            <li className={`p-2 ${listStore.page == listStore.page ? 'pg-active' : ''}`}>
               <a href="javascript:;"
                  className="pagination__link"
                  onClick={() => props.getList(listStore.page)}>
                  {listStore.page}
               </a>
            </li>

            {listStore.page <= listStore.lastPage - 1 &&
            <li className={`p-2 ${listStore.page == (listStore.page + 1) ? 'pg-active' : ''}`}>
               <a href="javascript:;" className="pagination__link"
                  onClick={() => props.getList(listStore.page + 1)}>
                  {listStore.page + 1}
               </a>
            </li>
            }

            {listStore.page <= listStore.lastPage - 2 &&
            <li className={`p-2 ${listStore.page == (listStore.page + 2) ? 'pg-active' : ''}`}>
               <a href="javascript:;"
                  className="pagination__link"
                  onClick={() => props.getList(listStore.page + 2)}>
                  {listStore.page + 2}
               </a>
            </li>
            }

            {listStore.page < listStore.lastPage - 2 &&
            <>
               <li className="p-2">
                  <a href="javascript:;" className="pagination__link" href="">...</a>
               </li>
               <li className={`p-2 ${listStore.page == listStore.lastPage ? 'pg-active' : ''}`}>
                  <a href="javascript:;"
                     className="pagination__link"
                     onClick={() => props.getList(listStore.lastPage)}>
                     {listStore.lastPage}
                  </a>
               </li>
            </>
            }
            {/* page numbers */}

            {listStore.page < listStore.lastPage &&
            <>
               <li className="p-2">
                  <a href="javascript:;" className="pagination__link"
                     onClick={() => props.getList(listStore.page + 1)}>
                     <Icons.ChevronLeft className="w-4 h-4"/>
                  </a>
               </li>
               <li className="p-2">
                  <a href="javascript:;" className="pagination__link"
                     onClick={() => props.getList(listStore.lastPage)}>
                     <Icons.ChevronsLeft className="w-4 h-4"/>
                  </a>
               </li>
            </>
            }
         </ul>
         <select onChange={(e) => (props.getList(1, e.target.value))}
                 className="w-20 form-select box mt-3 sm:mt-0">
            <option selected={listStore.perPage == 10} value="10">10</option>
            <option selected={listStore.perPage == 15} value="15">15</option>
            <option selected={listStore.perPage == 20} value="20">20</option>
            <option selected={listStore.perPage == 40} value="40">40</option>
            <option selected={listStore.perPage == 50} value="50">50</option>
         </select>
      </div>

   </>)
}